module.exports = __webpack_public_path__ + "img/bg22.3cce15d5.png";